import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Karadeniz Mahallesi Koltuk Yıkama", path: "/gaziosmanpasa/karadeniz-koltuk-yikama" },
  { label: "Karadeniz Mahallesi Yorgan Yıkama", path: "/gaziosmanpasa/karadeniz-yorgan-yikama" },
  { label: "Kazım Karabekir Koltuk Yıkama", path: "/gaziosmanpasa/kazim-karabekir-koltuk-yikama" },
  { label: "Kazım Karabekir Perde Yıkama", path: "/gaziosmanpasa/kazim-karabekir-perde-yikama" },
  { label: "Mevlana Mahallesi Koltuk Yıkama", path: "/gaziosmanpasa/mevlana-koltuk-yikama" },
  { label: "Mevlana Mahallesi Battaniye Yıkama", path: "/gaziosmanpasa/mevlana-battaniye-yikama" },
  { label: "Yenidoğan Mahallesi Koltuk Yıkama", path: "/gaziosmanpasa/yenidogan-koltuk-yikama" },
  { label: "Yenidoğan Mahallesi Kuru Temizleme", path: "/gaziosmanpasa/yenidogan-kuru-temizleme" },
  { label: "Bağlarbaşı Koltuk Yıkama", path: "/gaziosmanpasa/baglarbasi-koltuk-yikama" },
  { label: "Bağlarbaşı Yerinde Yıkama", path: "/gaziosmanpasa/baglarbasi-yerinde-yikama" },
  { label: "Gaziosmanpaşa Merkez Koltuk Yıkama", path: "/gaziosmanpasa/merkez-koltuk-yikama" }
];

const GaziosmanpasaServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          GAZİOSMANPAŞA HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default GaziosmanpasaServiceArea;
